import React, { useState, useCallback } from "react";
import axios from "../../utils/axios_interceptor"
import { useEffect } from "react";
import ProductCard from "../product-card/product-card";
import ProductsSlider from "../products-slider/products-slider";
import { getPdmApiUrl } from "../../utils/helper";
import "./recommendedProducts.scss";
import { throttle } from "lodash";

function RecommendedProducts({
  sceneType,
  relateCode,
  heading,
  backgroundColor,
  onAddToCart,
  itemCodes,
}) {
  const [products, setProducts] = useState([]);
  const sceneTypes = ["CATEGORY_RELATE", "SKU_RELATE"];
  let indexAndItemcodeMapobject = {};
  let newArray = [];
  const getRecommendedProducts = async (sceneType, relateCode) => {
    try {
      const requestObj = {
        sceneType: sceneType,
        ...(relateCode && { relateCode: [...relateCode] }),
      };
      const apiUrl = getPdmApiUrl();
      const response = await axios.post(`/recommendProducts`, requestObj, {
        baseURL: apiUrl,
      });
      setProducts(
        response?.data && response?.data?.products?.length
          ? response?.data?.products
          : []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getProducts = async (itemCodes) => {
    try {
      const requestObj = {
        itemCodes: itemCodes,
      };
      const apiUrl = getPdmApiUrl();
      const response = await axios.post(`/plp/list`, requestObj, {
        baseURL: apiUrl,
      });
      itemCodes?.map(
        (itemCode, index) => (indexAndItemcodeMapobject[itemCode] = index)
      );

      response?.data?.content?.map((item, i) => {
        newArray[indexAndItemcodeMapobject[item?.itemCode]] = item;
      });
      setProducts(newArray ? newArray : []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (itemCodes?.length) {
      getProducts(itemCodes);
    }
  }, [itemCodes]);

  const throttled = useCallback(
    throttle(
      (relateCode, sceneType) => getRecommendedProducts(sceneType, relateCode),
      2000
    ),
    []
  );

  useEffect(() => {
    if (!sceneType) return;

    if (sceneTypes.includes(sceneType) && !relateCode) {
      return;
    }
    throttled(relateCode, sceneType);
  }, [sceneType, relateCode]);

  return (
    <div className="container">
      {products && products.length ? (
        <ProductsSlider heading={heading} backgroundColor={backgroundColor}>
          {products && products.length
            ? products.map((product, i) => (
              <ProductCard
                key={i}
                product={product}
                Link={(props) => <a {...props} />}
                isHeart={false}
                onAddToCart={onAddToCart}
              />
            ))
            : null}
        </ProductsSlider>
      ) : null}
    </div>
  );
}

RecommendedProducts.defaultProps = {
  heading: "為您推薦",
  backgroundColor: "#FAFAFA",
};

export default RecommendedProducts;
